module.exports = __webpack_public_path__ + "static/img/git-stars.9149dd4.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/git-stars.png
// module id = 935
// module chunks = 2 8